import { get, set } from 'lodash';

import { APPLICANT_QUESTIONS, ENTITY_TYPE, FIELD_PATHS } from '@funnels/constants';
import {
  BrokerInterviews,
  FormValuesPostProductSelect,
  PostProductSelectContract,
  SubstantialBenefit,
} from '@funnels/types';

import { INITIAL_BROKER_INTERVIEW } from './initialFormValues';

export function setApplicantBrokerInterviewInitialValues(
  formValues: FormValuesPostProductSelect,
  applicationId: string
) {
  const postProductSelects = get(formValues, FIELD_PATHS.POST_PRODUCT_SELECTS(), []) as PostProductSelectContract[];
  const brokerInterviews = get(formValues, FIELD_PATHS.BROKER_INTERVIEWS(), []) as BrokerInterviews[];
  const hasPPSSubstantialBenefit = postProductSelects.some(
    (pps) =>
      get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_ENTITY_TYPE(0)) === ENTITY_TYPE.APPLICANT &&
      get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_QUESTIONS(0), [] as string[]).includes(
        APPLICANT_QUESTIONS.SUBSTANTIAL_BENEFITS
      )
  );

  const brokerInterviewIndex = brokerInterviews.some(
    (brokerInterview) =>
      get({ brokerInterviews: [brokerInterview] }, FIELD_PATHS.BROKER_INTERVIEW_APPLICATION_ID(0)) === applicationId
  )
    ? brokerInterviews.findIndex(
        (brokerInterview) =>
          get({ brokerInterviews: [brokerInterview] }, FIELD_PATHS.BROKER_INTERVIEW_APPLICATION_ID(0)) === applicationId
      )
    : brokerInterviews.length;

  // Initialise broker interview for the substantial benefit section if it doesn't exists yet
  if (hasPPSSubstantialBenefit && brokerInterviewIndex === brokerInterviews.length) {
    set(formValues, FIELD_PATHS.BROKER_INTERVIEWS(), [...brokerInterviews, INITIAL_BROKER_INTERVIEW(applicationId)]);
  }

  // Initialise broker interview substantialBenefit for each applicant if it doesn't exists yet
  if (hasPPSSubstantialBenefit) {
    const substantialBenefits = get(
      formValues,
      FIELD_PATHS.BROKER_INTERVIEW_SUBSTANTIAL_BENEFITS(brokerInterviewIndex),
      []
    );
    const substantialBenefitsToBeCreated: SubstantialBenefit[] = [];

    postProductSelects
      .filter(
        (pps) =>
          get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_ENTITY_TYPE(0)) === ENTITY_TYPE.APPLICANT &&
          get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_QUESTIONS(0), [] as string[]).includes(
            APPLICANT_QUESTIONS.SUBSTANTIAL_BENEFITS
          )
      )
      .forEach((pps) => {
        const applicantId = get({ postProductSelect: [pps] }, FIELD_PATHS.POST_PRODUCT_SELECT_ENTITY_ID(0));
        const hasApplicantSubstantialBenefit = substantialBenefits.some(
          (substantialBenefit: SubstantialBenefit) =>
            get(
              { brokerInterviews: [{ substantialBenefit: [substantialBenefit] }] },
              FIELD_PATHS.BROKER_INTERVIEW_SUBSTANTIAL_BENEFIT_APPLICANT_ID(0, 0)
            ) === applicantId
        );

        // Initialise substantialBenefit for the applicant if it doesn't exists yet
        if (!hasApplicantSubstantialBenefit) {
          substantialBenefitsToBeCreated.push({ applicantId });
        }
      });
    set(formValues, FIELD_PATHS.BROKER_INTERVIEW_SUBSTANTIAL_BENEFITS(brokerInterviewIndex), [
      ...substantialBenefits,
      ...substantialBenefitsToBeCreated,
    ]);
  }
}
